import React, { useEffect, useState } from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import { useTranslation } from 'react-i18next';

import LatestBooks from '../../graphql/queries/LatestBooks';
import { serializeBooks, serializeItem } from '../../helpers/serializers/Books';
import Collection from './Collection';

import './CollectionStyles.scss';

const CollectionIndexPage = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadLatest = () => {
    setLoading(true);
    LatestBooks.fetch({})
      .then((response) => {
        const edges =
          response?.latestBooks?.edges ||
          response?.booksLatest?.edges ||
          response?.books?.edges ||
          [];
        const serialized = serializeBooks(edges);
        setData(serialized);
      })
      .catch((error) => {
        console.error('Error fetching latest books:', error);
      })
      .finally(() => setLoading(false));
  };

  const updateBook = (updatedEntity) => {
    setData((prev) =>
      prev.map((book) => {
        if (!book.entities) return book;
        const idx = book.entities.findIndex((e) => e.id === updatedEntity.id);
        if (idx === -1) return book;
        const updatedEntities = [...book.entities];
        updatedEntities[idx] = updatedEntity;
        const updatedBook = { ...book, entities: updatedEntities };
        return serializeItem(updatedBook);
      })
    );
  };

  useEffect(() => {
    loadLatest();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 }, py: { xs: 1, md: 2 }, textAlign: { xs: 'center', sm: 'left' } }}>
      {loading && data.length === 0 ? (
        <Box textAlign="center" mt={4}>
          <Typography variant="body1">{t('loading', 'Завантаження...')}</Typography>
        </Box>
      ) : data.length === 0 ? (
        <Box textAlign="center" mt={6} mb={6} sx={{ color: 'text.secondary' }}>
          <SearchOffOutlinedIcon sx={{ fontSize: 64, mb: 1, opacity: 0.6 }} />
          <Typography variant="h6">{t('noLatest', 'Поки що немає нових надходжень')}</Typography>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Collection
            onUpdateEntity={updateBook}
            title=""
            items={data}
          />
        </Box>
      )}
    </Container>
  );
};

export default CollectionIndexPage;
